import React from 'react';
import {Col, Container, Row, Tab, Nav} from "react-bootstrap";

function Ourpractice(props) {
    return (
        <section className="tekgrip_section tekrevol_dark_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="my-auto">
                        <div className="example" data-text="LMS Solutions">
                            <h2>TekRevol’s LMS Development Process</h2>
                        </div>
                        <p className="main_para">At TekRevol, we start any development procedure with a strategic audit
                            and needs assessment of business objectives. Our team, including the LMS development
                            department, designers, and business analysts, follow an agile approach to bringing ideas
                            into successful digital realities. Here is our holistic process.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tekgrip_tabs">
                        <Tab.Container id="" defaultActiveKey="0">
                            <Row>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="0">Plan</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="1">Build</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="2">Transform</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={6} className="my-auto">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="0">
                                            <p>The first stage of development starts with a roadmap outlining the
                                                business size, requirements and future goals, and necessary features and
                                                LMS development objectives.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="1">
                                            <p>Creative designers translate the strategy document into UI and UX
                                                designs. After concept testing and the client’s approval, the designs
                                                establish the technical foundation with front-end, back-end, and API
                                                structures.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="2">
                                            <p>The LMS is ready to launch and deploy with code review and holistic
                                                in-house testing. Cloud-based LMS programs can be used right after
                                                deployment.</p>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>

                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Ourpractice;